import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
        ad: '',
        contacts: '',
        calendar: {
            actions: '',
            events: ''
        },
        budget: {
            analyse: '',
            analyseClass: '',
            result: '',
            showResult: false,
            showResultPart: ''
        },
        isReady: false,
        debugMessage: 'start',
        isApp: false,
        isConnected: true
    },

    mutations: {
        showBudgetResult(state) {
            state.budget.showResult = true;
        },
        hideBudgetResult(state) {
            state.budget.showResult = false;
        },
        isReady(state) {
            state.isReady = true;
        }
    }
});




// WEBPACK FOOTER //
// ./src/store/store.js